import React, {useMemo} from 'react';

import 'react-dropzone-uploader/dist/styles.css';
import { CContainer } from '@coreui/react';
import { useTranslation } from 'react-i18next';
import Table from './Table';
import { USER_TYPES } from '../helper';
import { SettingsModalBoldText } from '../views/settings/SettingsModals';
import { getRoomUnitTerminology } from '../utils/utils';
import {useGetConfigs} from '../hooks/useGetConfigs';
import styled from 'styled-components';

const replaceEmptyValue = (value) => (value ? value : '-');

const getErrorStyle = (field, errors) => {
  if (!Boolean(errors)) return {};
  return errors[field] ? { border: '3px solid red', backgroundColor: 'rgba(255, 0, 0, 0.1)' } : {};
};

const UsersFromCSVTable = ({ users = [], title }) => {
  const { t } = useTranslation();
  const {config} = useGetConfigs();

  const userfields = [
    { key: 'name', label: t('Name') },
    { key: 'email', label: t('Email Address') },
    { key: 'user_type', label: t('Type') },
    { key: 'mobile_phone', label: t('Cell Phone') },
    { key: 'home_phone', label: t('Home Phone') },
    { key: 'unit_num', label: getRoomUnitTerminology(config) },
    { key: 'rent', label: t('Rent') },
    { key: 'move_in', label: t('Move In Date') },
    { key: 'move_out', label: t('Move Out Date') }
  ];

  return (
    <>
      <SettingsModalBoldText fontSize="24px">{t(`${title}`)}</SettingsModalBoldText>
      <TableWrapper hasUsers={users.length > 0}>
        <Table
          items={users}
          fields={userfields}
          scopedSlots={{
            unit_num: (item, index) => {
              return <td className="addUsers-table-unit" style={getErrorStyle("unit_num", item?.errors)}>{item.unit_num}</td>;
            },
            user_type: (item, index) => {
              const userType = Object.entries(USER_TYPES).find(
                ([key, value]) => value === item.user_type
              );
              return <td className="addUsers-table-type" style={getErrorStyle("user_type", item?.errors)}>{userType?.length > 0 && userType[0]}</td>;
            },

            name: (item, index) => {
              return (
                <td className="addUsers-table-name" style={getErrorStyle("name", item?.errors)}>{`${item.first_name} ${item.last_name}`}</td>
              );
            },
            email: (item, index) => {
              return <td className="addUsers-table-email" style={getErrorStyle("email", item?.errors)}>{item.email}</td>;
            },
            rent: (item) => {
              return <td className="addUsers-table-unit">{replaceEmptyValue(item.rent)}</td>;
            },
            move_in: (item) => {
              return <td className="addUsers-table-date" style={getErrorStyle("move_in", item?.errors)}>{item.move_in}</td>;
            },
            move_out: (item) => {
              return <td className="addUsers-table-date" style={getErrorStyle("move_out", item?.errors)}>{item.move_out}</td>;
            },
            mobile_phone: (item) => {
              return <td className="addUsers-table-phone">{replaceEmptyValue(item.mobile_phone)}</td>;
            },
            home_phone: (item) => {
              return <td className="addUsers-table-phone">{replaceEmptyValue(item.home_phone)}</td>;
            }
          }}
        />
      </TableWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: flex;
  height: 150px;
  height: ${({ hasUsers }) => hasUsers ? '150px' : '60px'};
`;

export default UsersFromCSVTable;
